import PropTypes from 'prop-types'
import React from 'react'
import Trans from 'next-translate/Trans'
import config from 'SRC/config/config.json'
import { formatPriceEnding } from '../../../../../../functions/index'

export const PaidBonusAdsPrice = ({ packages, cost }) => {
  const text = config.registrationForm.package.paidBonusAdPrice

  return (
    <tr>
      <Trans
        i18nKey='common:packages_paidBonusAdPrice_text'
        components={{
          td: <td />,
          strong: <strong />
        }}
        defaultTrans='<td>Vrijednost Gratis <strong>plaćenih</strong> oglasa</td>'
      />
      {
        packages.map(item => <td key={item.id}>{formatPriceEnding(Number(cost) * Number(item.paidLimit))}</td>)
      }
    </tr>
  )
}
PaidBonusAdsPrice.propTypes = {
  cost: PropTypes.number.isRequired,
  packages: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    paidLimit: PropTypes.number
  })).isRequired
}

PaidBonusAdsPrice.defaultProps = {
  cost: 0,
  packages: []
}
